import adms_ap_v201_rdf_schema from '../../semantic/adms-ap_v2.01_rdf_schema.ttl.js';

const N3 = require('n3');
const { DataFactory } = N3;
const { namedNode } = DataFactory;

/**
 * Специальный класс для обработки онтологии ADMS
 */

class AdmsOntologyHelper {

	constructor() {
    const parser = new N3.Parser();
		this.storeADMS = new N3.Store();
    this.storeADMS.addQuads(parser.parse(adms_ap_v201_rdf_schema));
	};

  /** Возвращает список свойств, которые есть у типа.
   * Определяется по значению domain у типа.
   * Если  rdfType равен undefined, то возвращается список всех свойств 
   */
  getProperties(rdfType, purpose=undefined) {
      const quads = (rdfType==undefined) 
        ? 
        this.storeADMS.getQuads(null, namedNode('http://www.w3.org/2000/01/rdf-schema#domain'), null)
        :
        this.storeADMS.getQuads(null, namedNode('http://www.w3.org/2000/01/rdf-schema#domain'), namedNode(rdfType));
      return quads.map(quad => quad.subject.id);
  }

  /** Возвращает true, если свойство является литеральным. 
   * Определяется, что его тип или owl:AnnotationProperty или owl:DatatypeProperty
   */  
  isLiteralProperty(iriProperty){
    const quads =this.storeADMS.getQuads(namedNode(iriProperty), namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), null);
    const iris = quads.map(quad => quad.object.id);
    return iris.includes('http://www.w3.org/2002/07/owl#AnnotationProperty') || iris.includes('http://www.w3.org/2002/07/owl#DatatypeProperty');
    //http://www.w3.org/2002/07/owl#AnnotationProperty
  }

  /** Возвращает true, если свойство является ссылочным. 
   * Определяется, что его тип или owl:ObjectProperty
   */  
  isObjectProperty(iriProperty){
    const quads =this.storeADMS.getQuads(namedNode(iriProperty), namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), null);
    const iris = quads.map(quad => quad.object.id);
    return iris.includes('http://www.w3.org/2002/07/owl#ObjectProperty');
  }

  /** */
  getRanges(iriProperty){
    const quads =this.storeADMS.getQuads(namedNode(iriProperty), namedNode('http://www.w3.org/2000/01/rdf-schema#range'), null);
    const iris = quads.map(quad => quad.object.id);
    return iris;
  }
}

 export default AdmsOntologyHelper;